<div class="container-fluid">
    <div class="InvoiceHeader">
        <h2 mat-dialog-title style="color: white;font-size: 24px;">Today's Stock</h2>
        <div class="headerButton">
            <button type="button" class="btn btn-warning" matDialogClose (click)="close()"><i class="fa fa-times"
                    aria-hidden="true"></i> Close
            </button>
        </div>
    </div>
    <mat-dialog-content>
        <div class="card">
            <div class="card-body">
                <div class="bodyWrapper">
                    <div class="row">
                        <div class="col-lg-3">
                            <div class="card modalHeader">
                                <div class="form-group  required">
                                    <label class="col-lg-6">Body Parts</label>
                                    <br>
                                    <select class="col-lg-7" data-show-content="true"
                                     (change)="onBodyPartSelect($event)">
                                        <option selected="">Select Body Part</option>
                                        <option *ngFor="let data of dashboardModalData;"
                                            [selected]="data.name === bodyPartName" [value]="data.id"> {{data?.name}}
                                        </option>
                                    </select>
                                </div>

                                <div class="form-group  required">
                                    <label class="col-lg-5">Implant </label>
                                    <br>
                                    <select class="col-lg-7" data-show-content="true"
                                        [(ngModel)]="implantValue" (change)="implantSelected()">
                                        <option value="null">Select..</option>
                                        <option *ngFor="let implant of implantData" [selected]="implant.name == selectedImplant" [value]="implant.id">
                                            {{implant?.name}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-9">
                            <div class="card contentCardWrapper" style="height: 210px;">
                                <div class="contentChart">
                                    <div class="contentChartWrapper">
                                        <div [ngStyle]="{'background-color': imp.colour_code}" class="m1"
                                            *ngFor="let imp of implantModalData"
                                            (click)="openModalTable(imp.implant_id, imp.id)">
                                            <i class="fa fa-plus-square" aria-hidden="true"></i>
                                            <a> {{imp.name}}<br>(Availability - {{imp.count}})</a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <hr size="20">
                    <div *ngIf="productTableData?.data">
                        <h4> Products </h4>
                        <table class="table table-hover table-bordered">
                            <thead>
                                <tr>
                                    <th scope="col">Item Code</th>
                                    <th scope="col">Description</th>
                                    <th scope="col">Quantity</th>
                                    <th scope="col">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    *ngFor="let tbl of productItems |paginate: { id: 'dashboardModal_pagination', itemsPerPage: per_page, currentPage: page, totalItems: total_count}; ">
                                    <th scope="row">{{tbl.code}}</th>
                                    <td>{{tbl.name}}</td>
                                    <td>{{tbl.total_quantity}}</td>
                                    <td>
                                        <div class="status" [ngStyle]="{'background-color': tbl.colour_code}">
                                            {{tbl.color_code}} </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- <pagination-controls id="dashboardPage" (pageChange)="pageChange($event)">
                    </pagination-controls> -->


                </div>
                <div class="paginationWrapper" *ngIf="productTableData">
                    <pagination-template id="dashboardModal_pagination" #p="paginationApi"
                        (pageChange)=pageChange($event)>
                        <div class="pageheader">
                            <div class="firstIndex">
                                <a *ngIf="!p.isFirstPage()" (click)="p.setCurrent(1)">
                                    << </a> </div> <div class="pagination-previous">
                                        <a *ngIf="!p.isFirstPage()" (click)="p.previous()">
                                            < </a> </div> <div *ngFor="let page of p.pages"
                                                [class.current]="p.getCurrent() === page.value">
                                                <a (click)="p.setCurrent(page.value)"
                                                    *ngIf="p.getCurrent() !== page.value">
                                                    <span>{{ page.label }}</span>
                                                </a>
                                                <div *ngIf="p.getCurrent() === page.value">
                                                    <span>{{ page.label }}</span>

                                                </div>
                            </div>

                            <div class="pagination-next" [class.disabled]="p.isLastPage()">
                                <a *ngIf="!p.isLastPage()" (click)="p.next()"> > </a>
                            </div>
                            <div class="lastPageIndex">
                                <a *ngIf="!p.isLastPage()" (click)="p.setCurrent(p.getLastPage())"> >> </a>
                            </div>
                        </div>

                    </pagination-template>
                </div>
            </div>
        </div>


    </mat-dialog-content>

</div>
